import InputBase from '@material-ui/core/InputBase';
import Tooltip from '@material-ui/core/es/Tooltip/Tooltip';
import React from 'react';
import {connect} from 'react-redux';
import colors from '../../../../CSS/_variables.module.scss';
import {ReactComponent as Send} from '../../../../Images/svg/sendMessage.svg';
import {ReactComponent as OpenConference} from '../../../../Images/svg/videoConferenceButton.svg';
import Spinner from '../../../../SmallLayoutComponents/Spinner';
import {isWebview} from '../../../../Utils/is-webview';
import {preventDefaultDrag} from '../../../../Utils/utils';
import axios from '../../../../store/axios-instance';
import {isIOS} from 'react-device-detect';
class SendPrivateChatMessage extends React.PureComponent {
    constructor(props) {
        super(props);

        this.btnRef = React.createRef(false);
        this.newMessageRef = React.createRef();
        this.setButtonRef = this.setButtonRef.bind(this);
        this._handleSendMessage = this._handleSendMessage.bind(this);

        this.state = {
            newMessage: '',
            sendingMessage: false,
            isSending: false,
        };
    }

    chatMessagesContainer = document.getElementById('chat-messages-container');

    componentDidMount() {
        if (isIOS) this.btnRef = true;
        const {isLargeScreen} = this.props;
        if (isLargeScreen) {
            this.newMessageRef.current.focus();
        }
        document.addEventListener('mousedown', this._handleSendMessage);
    }

    componentDidUpdate(prevProps) {
        if (this.props.activeChatRoomId !== prevProps.activeChatRoomId) {
            this.setState({newMessage: ''});
            this.newMessageRef.current.focus();
        }
    }

    componentWillUnmount() {
        const eventPage = document.getElementsByClassName('event-page hide-new-chat-message');
        if (eventPage.length !== 0) {
            eventPage[0].classList.remove('hide-new-chat-message');
        }
        document.removeEventListener('mousedown', this._handleSendMessage);
        clearTimeout(this.sendMessageTimeoutId);
        clearTimeout(this.inputFocusTimeoutId);
        clearTimeout(this.inputBlurTimeoutId);
    }

    setButtonRef = (node) => (this.sendButton = node);

    handleChange = (name) => (event) =>
        this.setState({
            [name]: event.target.value,
        });

    handleKeyDown = (e) => {
        const {newMessage} = this.state;
        if (e.key === 'Enter' && newMessage.trim()) {
            this.onSendPrivateMessage(e);
        }
    };

    onSendPrivateMessage = (e) => {
        const {sendingMessage, newMessage} = this.state;
        if (e) {
            e.preventDefault();
        }

        this.setState({sendingMessage: true});
        if (!sendingMessage) {
            axios({
                method: 'post',
                url: '/private-chat/' + this.props.activeChatRoomId + '/messages',
                data: {text: newMessage},
            }).then((response) => {
                this.setState({newMessage: '', sendingMessage: false});
                if (this.newMessageRef.current) {
                    this.newMessageRef.current.focus();
                }
                /*
                this.btnRef = false;
*/
            });
        }
        this.sendMessageTimeoutId = setTimeout(() => {
            if (this.chatMessagesContainer) {
                this.chatMessagesContainer.scroll({top: this.chatMessagesContainer.scrollHeight, behavior: 'smooth'});
            }
        }, 500);
    };

    startConference = () =>
        this.setState({newMessage: "I've set up a Video Meeting room. Please click here to join it."}, () => {
            this.onSendPrivateMessage();
            this.props.startConference();
        });

    _handleSendMessage = (event) => {
        if (this.sendButton && this.sendButton.contains(event.target)) {
            this.setState({
                isSending: true,
            });
        } else {
            this.setState({
                isSending: false,
            });
        }
    };

    handleInputFocus = () => {
        if (isIOS) {
            this.btnRef = false;
        }

        const eventPage = document.getElementsByClassName('event-page');
        if (eventPage) {
            eventPage[0].classList.add('hide-new-chat-message');
        }
        this.inputFocusTimeoutId = setTimeout(() => {
            if (this.chatMessagesContainer) {
                this.chatMessagesContainer.scroll({top: this.chatMessagesContainer.scrollHeight, behavior: 'smooth'});
            }
            if (isIOS) {
                this.btnRef = true;
            }
        }, 500);
    };

    handleInputBlur = () => {
        const {isSending} = this.state;
        if (isIOS) {
            this.btnRef = true;
        }

        if (!isSending) {
            const eventPage = document.getElementsByClassName('event-page hide-new-chat-message');
            if (eventPage.length !== 0) {
                eventPage[0].classList.remove('hide-new-chat-message');
            }
            this.inputBlurTimeoutId = setTimeout(() => {
                if (this.chatMessagesContainer) {
                    this.chatMessagesContainer.scroll({
                        top: this.chatMessagesContainer.scrollHeight,
                        behavior: 'smooth',
                    });
                }
            }, 500);
        }
    };

    render() {
        const {newMessage, sendingMessage} = this.state;
        const {translation, joinBannerActive, videoConferenceActive} = this.props;
        return (
            <form autoComplete={'off'} className="chat-message-form" onSubmit={this.onSendPrivateMessage}>
                <div
                    onDragStart={preventDefaultDrag}
                    style={{marginBottom: this.btnRef === true ? '55px' : '16px'}}
                    className={'new-comment-container'}
                >
                    {sendingMessage && <Spinner />}
                    <InputBase
                        id="newMessage"
                        multiline={true}
                        maxRows={4}
                        placeholder={translation?.chatsDropdown.newMessageInput}
                        value={newMessage}
                        onChange={this.handleChange('newMessage')}
                        onKeyDown={this.handleKeyDown}
                        onFocus={this.handleInputFocus}
                        onBlur={this.handleInputBlur}
                        ref={this.newMessageRef}
                    />
                    {newMessage ? (
                        <button disabled={!newMessage.trim() || sendingMessage} type="submit" ref={this.setButtonRef}>
                            <Send fill={colors.primary} />
                        </button>
                    ) : joinBannerActive || videoConferenceActive ? (
                        <button disabled>
                            <Send fill={colors.grey} />
                        </button>
                    ) : isWebview() ? null : (
                        <Tooltip arrow title={translation?.chatsDropdown.newVideoCallTooltipText}>
                            <button
                                onClick={this.startConference}
                                className="video-conference-button dawdaw"
                                type="button"
                            >
                                <OpenConference fill={colors.primary} />
                            </button>
                        </Tooltip>
                    )}
                </div>
            </form>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        activeChatRoomId: state.user.topNavigation.activeChatRoomId,
        isLargeScreen: state.layout.isLargeScreen,
        languages: state.languages,
        translation: state.languages.translations[state.languages.platformLanguage],
        defaultTranslation: state.languages.translations['en'],
    };
};

export default connect(mapStateToProps)(SendPrivateChatMessage);
